import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from "framer-motion";
import { Calendar, User, ArrowRight, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Layout/Navbar';
import Footer from '@/components/Layout/Footer';

const BlogList = () => {
  const blogPosts = [
    // Existing posts
    {
      id: 52,
      title: "Workflow Automation Services for SMEs: 5 Processes Every Business Should Automate First",
      slug: "workflow-automation-services-smes-5-processes",
      description: "Workflow automation services are one of the simplest and most cost-effective ways for UK businesses to save time, reduce errors, and boost productivity. Discover the 5 workflows every business should automate first.",
      author: "Njord AI Team",
      date: "September 16, 2025",
      readTime: "8 min read",
      category: "Workflow Automation",
      featured: false
    },
    {
      id: 51,
      title: "AI Consulting Services: A Practical Guide for UK Businesses",
      slug: "ai-consulting-services-for-uk-smes-where-to-start",
      description: "For many small and medium-sized businesses in the UK, 'AI' can feel like a buzzword reserved for big tech. This guide explains what AI consulting involves, the benefits it brings, and how to take your first steps.",
      author: "Njord AI Team",
      date: "September 16, 2025",
      readTime: "12 min read",
      category: "AI Consulting",
      featured: true
    },
    
    // New blog posts (placeholder content)
    {
      id: 50,
      title: "AI Chatbots for Customer Service: Complete Guide",
      slug: "ai-chatbots-customer-service-complete-guide",
      description: "Discover how AI chatbots transform customer service. Implementation guide, benefits, and best practices for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "10 min read",
      category: "AI Customer Service",
      featured: false
    },
    {
      id: 49,
      title: "Automated Lead Generation: Complete Strategy Guide",
      slug: "automated-lead-generation-complete-strategy",
      description: "Master automated lead generation with AI. Strategies, tools, and implementation guide for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "15 min read",
      category: "Lead Generation",
      featured: false
    },
    {
      id: 48,
      title: "Business Process Automation: Ultimate Guide for SMEs",
      slug: "business-process-automation-ultimate-guide",
      description: "Transform your business with process automation. Complete guide to BPA implementation, tools, and ROI for UK SMEs.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "20 min read",
      category: "Process Automation",
      featured: false
    },
    {
      id: 47,
      title: "AI Voice Agents: The Future of Phone Support",
      slug: "ai-voice-agents-future-phone-support",
      description: "Discover how AI voice agents revolutionize phone support. Implementation guide and benefits for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "12 min read",
      category: "Voice AI",
      featured: false
    },
    {
      id: 46,
      title: "Appointment Scheduling Automation: Complete Guide",
      slug: "appointment-scheduling-automation-complete-guide",
      description: "Automate your appointment scheduling with AI. Complete implementation guide for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "14 min read",
      category: "Scheduling",
      featured: false
    },
    {
      id: 45,
      title: "CRM Integration with AI: Boost Sales Efficiency",
      slug: "crm-integration-ai-boost-sales-efficiency",
      description: "Integrate AI with your CRM system. Complete guide to AI-powered CRM automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "16 min read",
      category: "CRM Automation",
      featured: false
    },
    {
      id: 44,
      title: "AI Website Development: Smart Sites That Convert",
      slug: "ai-website-development-smart-sites-convert",
      description: "Build AI-powered websites that convert visitors into customers. Complete development guide for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "18 min read",
      category: "Web Development",
      featured: false
    },
    {
      id: 43,
      title: "Email Marketing Automation: Complete Strategy Guide",
      slug: "email-marketing-automation-complete-strategy",
      description: "Master email marketing automation with AI. Complete strategy and implementation guide for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "22 min read",
      category: "Email Marketing",
      featured: false
    },
    {
      id: 42,
      title: "AI Implementation Guide: Step-by-Step for SMEs",
      slug: "ai-implementation-guide-step-by-step-smes",
      description: "Complete AI implementation guide for UK SMEs. Step-by-step process, tools, and best practices.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "25 min read",
      category: "AI Implementation",
      featured: false
    },
    {
      id: 41,
      title: "Sales Automation Tools: Best Options for UK SMEs",
      slug: "sales-automation-tools-best-options-uk-smes",
      description: "Discover the best sales automation tools for UK SMEs. Complete comparison and implementation guide.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "18 min read",
      category: "Sales Automation",
      featured: false
    },
    {
      id: 40,
      title: "Customer Service Automation: Complete Implementation Guide",
      slug: "customer-service-automation-complete-implementation",
      description: "Automate customer service with AI. Complete implementation guide and best practices for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "20 min read",
      category: "Customer Service",
      featured: false
    },
    {
      id: 39,
      title: "AI Data Analytics: Transform Business Intelligence",
      slug: "ai-data-analytics-transform-business-intelligence",
      description: "Leverage AI for data analytics and business intelligence. Complete guide for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "24 min read",
      category: "Data Analytics",
      featured: false
    },
    {
      id: 38,
      title: "Marketing Automation Platforms: Best Options for SMEs",
      slug: "marketing-automation-platforms-best-options-smes",
      description: "Compare the best marketing automation platforms for UK SMEs. Complete guide and recommendations.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "19 min read",
      category: "Marketing Automation",
      featured: false
    },
    {
      id: 37,
      title: "AI SEO Optimization: Boost Rankings with AI",
      slug: "ai-seo-optimization-boost-rankings",
      description: "Use AI to optimize your SEO strategy. Complete guide to AI-powered SEO for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "21 min read",
      category: "SEO Automation",
      featured: false
    },
    {
      id: 36,
      title: "Inventory Management Automation: Complete Guide",
      slug: "inventory-management-automation-complete-guide",
      description: "Automate inventory management with AI. Complete implementation guide for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "17 min read",
      category: "Inventory Management",
      featured: false
    },
    {
      id: 35,
      title: "AI Content Generation: Scale Your Content Strategy",
      slug: "ai-content-generation-scale-content-strategy",
      description: "Scale content creation with AI. Complete guide to AI content generation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "16 min read",
      category: "Content Marketing",
      featured: false
    },
    {
      id: 34,
      title: "Social Media Automation: Complete Strategy Guide",
      slug: "social-media-automation-complete-strategy",
      description: "Automate your social media strategy with AI. Complete implementation guide for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "13 min read",
      category: "Social Media",
      featured: false
    },
    {
      id: 33,
      title: "AI Predictive Analytics: Forecast Business Success",
      slug: "ai-predictive-analytics-forecast-business-success",
      description: "Use AI predictive analytics to forecast business trends. Complete implementation guide for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "23 min read",
      category: "Predictive Analytics",
      featured: false
    },
    {
      id: 32,
      title: "HR Automation Systems: Streamline Human Resources",
      slug: "hr-automation-systems-streamline-human-resources",
      description: "Automate HR processes with AI. Complete guide to HR automation systems for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "19 min read",
      category: "HR Automation",
      featured: false
    },
    {
      id: 31,
      title: "AI Financial Analysis: Smart Financial Insights",
      slug: "ai-financial-analysis-smart-financial-insights",
      description: "Use AI for financial analysis and insights. Complete guide to AI-powered financial tools for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "26 min read",
      category: "Financial Analysis",
      featured: false
    },
    {
      id: 30,
      title: "E-commerce Automation: Complete Guide for Online Stores",
      slug: "ecommerce-automation-complete-guide-online-stores",
      description: "Automate your e-commerce operations with AI. Complete guide for UK online retailers.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "20 min read",
      category: "E-commerce",
      featured: false
    },
    {
      id: 29,
      title: "AI Project Management: Optimize Team Productivity",
      slug: "ai-project-management-optimize-team-productivity",
      description: "Use AI to enhance project management. Complete guide to AI-powered project tools for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "17 min read",
      category: "Project Management",
      featured: false
    },
    {
      id: 28,
      title: "Document Automation: Streamline Paperwork with AI",
      slug: "document-automation-streamline-paperwork-ai",
      description: "Automate document processing with AI. Complete guide to document automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "15 min read",
      category: "Document Management",
      featured: false
    },
    {
      id: 27,
      title: "AI Quality Assurance: Automated Testing Solutions",
      slug: "ai-quality-assurance-automated-testing-solutions",
      description: "Implement AI quality assurance systems. Complete guide to automated testing for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "18 min read",
      category: "Quality Assurance",
      featured: false
    },
    {
      id: 26,
      title: "Supply Chain Automation: Optimize Logistics with AI",
      slug: "supply-chain-automation-optimize-logistics-ai",
      description: "Automate supply chain operations with AI. Complete guide to logistics automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "22 min read",
      category: "Supply Chain",
      featured: false
    },
    {
      id: 25,
      title: "AI Cybersecurity: Protect Your Business with AI",
      slug: "ai-cybersecurity-protect-business-ai",
      description: "Enhance cybersecurity with AI. Complete guide to AI-powered security solutions for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "21 min read",
      category: "Cybersecurity",
      featured: false
    },
    {
      id: 24,
      title: "Reporting Automation: Automated Business Reports",
      slug: "reporting-automation-automated-business-reports",
      description: "Automate business reporting with AI. Complete guide to automated reporting systems for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "14 min read",
      category: "Business Intelligence",
      featured: false
    },
    {
      id: 23,
      title: "AI Compliance Management: Automate Regulatory Compliance",
      slug: "ai-compliance-management-automate-regulatory-compliance",
      description: "Automate compliance management with AI. Complete guide to regulatory compliance automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "25 min read",
      category: "Compliance",
      featured: false
    },
    {
      id: 22,
      title: "Database Automation: Streamline Data Management",
      slug: "database-automation-streamline-data-management",
      description: "Automate database operations with AI. Complete guide to database automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "19 min read",
      category: "Database Management",
      featured: false
    },
    {
      id: 21,
      title: "AI Risk Management: Identify and Mitigate Business Risks",
      slug: "ai-risk-management-identify-mitigate-business-risks",
      description: "Use AI for risk management and mitigation. Complete guide to AI-powered risk assessment for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "23 min read",
      category: "Risk Management",
      featured: false
    },
    {
      id: 20,
      title: "Network Automation: Optimize IT Infrastructure",
      slug: "network-automation-optimize-it-infrastructure",
      description: "Automate network management with AI. Complete guide to network automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "20 min read",
      category: "IT Infrastructure",
      featured: false
    },
    {
      id: 19,
      title: "AI Performance Monitoring: Track Business Metrics",
      slug: "ai-performance-monitoring-track-business-metrics",
      description: "Monitor business performance with AI. Complete guide to AI-powered performance tracking for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "17 min read",
      category: "Performance Monitoring",
      featured: false
    },
    {
      id: 18,
      title: "Backup Automation: Secure Data Protection Systems",
      slug: "backup-automation-secure-data-protection-systems",
      description: "Automate data backup and recovery with AI. Complete guide to backup automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "16 min read",
      category: "Data Protection",
      featured: false
    },
    {
      id: 17,
      title: "AI Decision Support: Smart Business Decision Making",
      slug: "ai-decision-support-smart-business-decision-making",
      description: "Make better decisions with AI support systems. Complete guide to AI decision support for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "24 min read",
      category: "Decision Support",
      featured: false
    },
    {
      id: 16,
      title: "Cloud Automation: Optimize Cloud Infrastructure",
      slug: "cloud-automation-optimize-cloud-infrastructure",
      description: "Automate cloud operations with AI. Complete guide to cloud automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "21 min read",
      category: "Cloud Computing",
      featured: false
    },
    {
      id: 15,
      title: "AI Resource Optimization: Maximize Business Efficiency",
      slug: "ai-resource-optimization-maximize-business-efficiency",
      description: "Optimize business resources with AI. Complete guide to AI-powered resource management for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "18 min read",
      category: "Resource Management",
      featured: false
    },
    {
      id: 14,
      title: "Security Automation: Protect Your Business Automatically",
      slug: "security-automation-protect-business-automatically",
      description: "Automate security operations with AI. Complete guide to security automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "22 min read",
      category: "Security",
      featured: false
    },
    {
      id: 13,
      title: "AI Workforce Management: Optimize Team Performance",
      slug: "ai-workforce-management-optimize-team-performance",
      description: "Manage your workforce with AI. Complete guide to AI-powered workforce management for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "19 min read",
      category: "Workforce Management",
      featured: false
    },
    {
      id: 12,
      title: "DevOps Automation: Streamline Development Operations",
      slug: "devops-automation-streamline-development-operations",
      description: "Automate DevOps processes with AI. Complete guide to DevOps automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "23 min read",
      category: "DevOps",
      featured: false
    },
    {
      id: 11,
      title: "AI Business Intelligence: Smart Data-Driven Decisions",
      slug: "ai-business-intelligence-smart-data-driven-decisions",
      description: "Transform business intelligence with AI. Complete guide to AI-powered BI solutions for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "27 min read",
      category: "Business Intelligence",
      featured: false
    },
    {
      id: 10,
      title: "Testing Automation: Automated Quality Assurance",
      slug: "testing-automation-automated-quality-assurance",
      description: "Automate software testing with AI. Complete guide to testing automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "20 min read",
      category: "Software Testing",
      featured: false
    },
    {
      id: 9,
      title: "AI Customer Insights: Understand Your Customers Better",
      slug: "ai-customer-insights-understand-customers-better",
      description: "Gain customer insights with AI. Complete guide to AI-powered customer analytics for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "15 min read",
      category: "Customer Analytics",
      featured: false
    },
    {
      id: 8,
      title: "Deployment Automation: Streamline Software Releases",
      slug: "deployment-automation-streamline-software-releases",
      description: "Automate software deployment with AI. Complete guide to deployment automation for UK businesses.",
      author: "Njord AI Team",
      date: "Coming Soon",
      readTime: "18 min read",
      category: "Software Deployment",
      featured: false
    }
  ];

  const blogSchema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "Njord AI Blog",
    "description": "Expert insights on AI automation, business process optimisation, and practical AI implementation for UK businesses.",
    "url": "https://www.njordai.co.uk/blog",
    "publisher": {
      "@type": "Organization",
      "name": "Njord AI Automation Agency",
      "logo": {
        "@type": "ImageObject",
        "url": "https://nnhioeyroijmrflqutee.supabase.co/storage/v1/object/public/njordai//NJORD%20W.png"
      }
    },
    "blogPost": blogPosts.map(post => ({
      "@type": "BlogPosting",
      "headline": post.title,
      "description": post.description,
      "url": `https://www.njordai.co.uk/blog/${post.slug}`,
      "datePublished": "2025-09-16",
      "author": {
        "@type": "Organization",
        "name": "Njord AI Automation Agency"
      }
    }))
  };

  return (
    <>
      <Helmet>
        <title>AI Automation Blog | Njord - Expert Insights & Practical Guides</title>
        <meta name="description" content="Expert insights on AI automation, business process optimization, and practical AI implementation for UK businesses. Read our latest guides and case studies." />
        <meta name="keywords" content="AI automation blog, business process automation, AI consulting insights, UK business automation, workflow optimization, AI implementation guides" />
        <meta property="og:title" content="AI Automation Blog | Njord - Expert Insights & Practical Guides" />
        <meta property="og:description" content="Expert insights on AI automation, business process optimization, and practical AI implementation for UK businesses." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.njordai.co.uk/blog" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="AI Automation Blog | Njord - Expert Insights & Practical Guides" />
        <meta name="twitter:description" content="Expert insights on AI automation, business process optimization, and practical AI implementation for UK businesses." />
        <link rel="canonical" href="https://www.njordai.co.uk/blog" />
        
        {/* Blog Schema */}
        <script type="application/ld+json">
          {JSON.stringify(blogSchema)}
        </script>
      </Helmet>
      
      <Navbar />
      
      <div className="bg-white min-h-screen">
        {/* Header */}
        <div className="bg-gradient-to-b from-gray-50 to-white py-20 pt-32">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <h1 className="text-4xl md:text-5xl font-bold text-black mb-6">
                  AI Automation Insights
                </h1>
                <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
                  Expert insights on AI automation, business process optimization, and practical implementation strategies for UK businesses.
                </p>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Blog Posts Grid */}
        <div className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {blogPosts.map((post, index) => (
                  <motion.div
                    key={post.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                  >
                    <Link 
                      to={`/blog/${post.slug}`}
                      className="block group"
                    >
                      <div className="bg-white border-2 border-gray-200 rounded-lg p-6 h-full hover:border-primary hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                        {post.featured && (
                          <div className="inline-block bg-primary text-white px-3 py-1 rounded-full text-sm font-medium mb-4">
                            Featured
                          </div>
                        )}
                        
                        <div className="mb-4">
                          <span className="inline-block bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
                            {post.category}
                          </span>
                        </div>

                        <h2 className="text-xl font-bold text-black mb-3 group-hover:text-primary transition-colors duration-300 line-clamp-2">
                          {post.title}
                        </h2>

                        <p className="text-gray-600 mb-4 line-clamp-3 leading-relaxed">
                          {post.description}
                        </p>

                        <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                          <div className="flex items-center space-x-4">
                            <div className="flex items-center">
                              <Calendar className="h-4 w-4 mr-1" />
                              <span>{post.date}</span>
                            </div>
                            <div className="flex items-center">
                              <Clock className="h-4 w-4 mr-1" />
                              <span>{post.readTime}</span>
                            </div>
                          </div>
                        </div>

                        <div className="flex items-center justify-between">
                          <div className="flex items-center">
                            <User className="h-4 w-4 mr-2 text-gray-400" />
                            <span className="text-sm text-gray-600">{post.author}</span>
                          </div>
                          
                          <div className="flex items-center text-primary group-hover:text-primary-600 transition-colors duration-300">
                            <span className="text-sm font-medium mr-1">Read More</span>
                            <ArrowRight className="h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-300" />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </motion.div>
                ))}
              </div>

              {/* Coming Soon Section */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                className="mt-16 text-center"
              >
                <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-12">
                  <h3 className="text-2xl font-bold text-gray-700 mb-4">More Insights Coming Soon</h3>
                  <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                    We're working on more comprehensive guides covering workflow automation, AI implementation strategies, and real-world case studies from UK businesses.
                  </p>
                  <div className="flex flex-wrap justify-center gap-3">
                    {[
                      "Workflow Automation Case Studies",
                      "AI Implementation Roadmaps", 
                      "ROI Measurement Strategies",
                      "Industry-Specific AI Solutions"
                    ].map((topic, index) => (
                      <span 
                        key={index}
                        className="bg-white border border-gray-200 px-4 py-2 rounded-full text-sm text-gray-600"
                      >
                        {topic}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BlogList;